import { InvoiceBatchLocale } from 'api'
import { currencyFormat } from '../../../helpers/currencyCalculation'
import { BatchSummary } from '../../../models'
import React from 'react'

interface InvoiceBatchSummaryProps {
    summary: BatchSummary
    locale: InvoiceBatchLocale
}

export function InvoiceBatchSummary(props: InvoiceBatchSummaryProps) {
    const { summary, locale } = props

    return (
        <div className='col-6 mt-5'>
            <table className='table'>
                <thead>
                    <tr>
                        <th>{locale === 'domestic_locales' ? 'Domestic' : 'International'}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>Total Invoices</th>
                        <td>{summary.totalInvoices}</td>
                    </tr>
                    <tr>
                        <th>Total Amount</th>
                        <td>{currencyFormat(summary.totalAmount)}</td>
                    </tr>
                    <tr>
                        <th>Total Records</th>
                        <td>{summary.totalRecords}</td>
                    </tr>
                    <tr>
                        <th>Average Invoice Amount</th>
                        <td>{currencyFormat(summary.averageInvoiceAmount)}</td>
                    </tr>
                    <tr>
                        <th>Average Records per Invoice</th>
                        <td>{summary.averageRecordsPerInvoice}</td>
                    </tr>
                    <tr>
                        <th>Average Record Amount</th>
                        <td>{currencyFormat(summary.averageRecordAmount)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}
